import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import leaflet from 'leaflet'
import maplibregl from 'maplibre-gl'
import 'maplibre-gl/dist/maplibre-gl.css'
import '@maplibre/maplibre-gl-leaflet'
// CRA's babel pass over node_modules corrupts the worker maplibre builds
// from an inline blob (the transpiled code references babel helpers that
// don't exist in the worker scope). The `!!` prefix bypasses every
// configured loader (including babel) so file-loader emits the pre-built
// worker file byte-for-byte and gives us its URL.
// This is the CRA transpilation workaround documented by Mapbox/MapLibre:
// https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling
// eslint-disable-next-line import/no-webpack-loader-syntax
import maplibreglWorkerUrl from '!!file-loader!maplibre-gl/dist/maplibre-gl-csp-worker'

maplibregl.workerUrl = maplibreglWorkerUrl

// OpenFreeMap serves OpenStreetMap-based vector tiles free for commercial
// use, with no API key or usage limits (https://openfreemap.org).
const MAP_STYLE_URL = 'https://tiles.openfreemap.org/styles/liberty'

const VectorBasemap = () => {
  const map = useMap()

  useEffect(() => {
    // Credits are rendered by the Leaflet AttributionControl in
    // CompetitorMap, not by MapLibre's own attribution box
    const layer = leaflet.maplibreGL({
      style: MAP_STYLE_URL,
      attributionControl: false,
    })
    layer.addTo(map)
    return () => {
      map.removeLayer(layer)
    }
  }, [map])

  return null
}

export { VectorBasemap }
